<script>
import { Doughnut } from "vue-chartjs";

export default {
  props: {
    occupied: Number,
  },
  extends: Doughnut,
  mounted() {
    this.renderChart(
      {
        labels: ["Occupied", "Free"],
        datasets: [
          {
            data: [this.occupied, 100 - this.occupied],
            backgroundColor: ["#556ee6", "#ebeff2"],
            hoverBackgroundColor: ["#556ee6", "#ebeff2"],
            hoverBorderColor: "#fff",
            borderWidth: 0,
            radius: "90%",
            innerRadius: "75%",
          },
        ],
      },
      {
        maintainAspectRatio: true,
      }
    );
  },
};
</script>
